import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import { GET_SHOPPINGS, GET_REPORTS_BY_DATE, GET_SHOPPING, CONFIRM_PAYMENT, CONFIRM_SHIPPING, CONFIRM_DELIVERY, DENY_SHOPPING, CANCEL_SHOPPING } from './actions.type';
import { SET_SHOPPINGS, SET_SHOPPING, FETCH_START, FETCH_END, SET_REPORTS } from './mutations.type';

const state = {
  shoppings: [],
  reports: [],
  loadingShoppings: false,
  shopping: {}
}
const getters = {
  shoppings: state => state.shoppings,
  reports: state => state.reports,
  loadingShoppings: state => state.loadingShoppings,
  shopping: state => state.shopping
}
const mutations = {
  [SET_SHOPPINGS] (state, shoppings) {
    state.shoppings = shoppings
  },
  [SET_REPORTS] (state, reports) {
    state.reports = reports
  },
  [SET_SHOPPING] (state, shopping) {
    state.shopping = shopping
  },
  [FETCH_START] (state) {
    Nprogress.start()
    state.loadingShoppings = true
  },
  [FETCH_END] (state) {
    Nprogress.done()
    state.loadingShoppings = false
  }
}
const actions = {
  async [GET_SHOPPINGS] ({ commit }) {
    try {
      commit(FETCH_START)
      const { data } = await api.get('bill')
      commit(SET_SHOPPINGS, data)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_REPORTS_BY_DATE] ({ commit }, dates) {
    try {
      commit(FETCH_START)
      const { data } = await api.post('bill', {initial_date: dates.startDate, final_date: dates.finalDate})
      commit(SET_REPORTS, data)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_SHOPPING] ({ commit }, shoppingId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`bill/${shoppingId}`)
      commit(SET_SHOPPING, data)
      commit(FETCH_END)
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [CONFIRM_PAYMENT] ({ commit }, billId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`bill/${billId}/verify`)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Pago confirmado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al confirmar el pago'
      })
    }
  },
  async [CONFIRM_DELIVERY] ({ commit }, billId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`bill/${billId}/delivery`)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Entrega confirmada exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al confirmar la entrega'
      })
    }
  },
  async [CONFIRM_SHIPPING] ({ commit }, billId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`bill/${billId}/shipping`)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Envio confirmado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al confirmar el envio'
      })
    }
  },
  async [DENY_SHOPPING] ({commit}, billId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`bill/${billId}/reject`)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Pago denegado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al denegar el pago'
      })
    }
  },
  async [CANCEL_SHOPPING] ({commit}, { billId, reason } ) {
    try {
      commit(FETCH_START)
      const { data } = await api.post(`bill/${billId}/cancel`, { note: reason })
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Venta cancelada exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al cancelar la venta'
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}